import { gql, useQuery } from "@apollo/client";
import { useModals } from "ModalProvider";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import SearchBar from "components/base/SearchBar";
import Spinner from "components/base/Spinner";
import Button from "components/base/Button";
import { Link } from "react-router-dom";
import RetailerForm from "./RetailerForm";

const FETCH_RETAILER_CUSTOMERS = gql`
  query FETCH_RETAILER_CUSTOMERS {
    retailerCustomers {
      id
      email
    }
  }
`;

const RetailerList = () => {
  const modal = useModals();

  const { loading, error, data } = useQuery(FETCH_RETAILER_CUSTOMERS, {
    fetchPolicy: "network-only",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  function showCreateView() {
    modal.present({
      title: "Create Retailer",
      children: <RetailerForm hide={modal.hide} />,
      isBeingPresented: true,
    });
  }

  return (
    <Page title="Retailers">
      <div className="card m-6 p-6">
        <div className="flex items-center justify-between space-x-4">
          <div className="flex-1">
            <SearchBar placeholder="Search by email or username." />
          </div>
          <Button onClick={showCreateView}>
            + Create Retailer
          </Button>
        </div>

        <div className="mt-4">
          <table>
            <thead>
              <tr>
                <th>Retailer Email</th>
              </tr>
            </thead>
            <tbody>
              {data.retailerCustomers.map((retailer) => (
                <tr key={retailer.id} className="border-y dark:border-gray-700">
                  <td>
                    <Link to={retailer.id}>{retailer.email}</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Page>
  );
};

export default RetailerList;
